import { BaseResource } from '../base-resource';

export class EventConfiguration extends BaseResource {
    constructor() {
        super();
        this.type = "EventConfiguration";
    }
}